import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData(id, item, file, expiryDate, status) {
  return { id, item, file, expiryDate, status };
}

const rows = [
  createData(
    "1",
    "Pay Offer",
    "Cameron Williamson.pdf",
    "19-02-2023",
    "Pending"
  ),
  createData(
    "2",
    "Pay Offer",
    "Cameron Williamson.pdf",
    "19-02-2023",
    "Pending"
  ),

  createData(
    "3",
    "Pay Offer",
    "Cameron Williamson.pdf",
    "19-02-2023",
    "Pending"
  ),
];

function ApplicantFileAttentionTableRow() {

  return (
    <div className="attention ">
      <TableContainer component={Paper} className="tableContainer">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: "#FAFAFB" }}>
            <TableRow>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                #
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                Item
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                File
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                Expiration Date
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] customTableHead"
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" className="customTableBody">
                  {row.id}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  {row.item}
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  <div className="flex gap-4 justify-start">
                    <svg
                      width="19"
                      height="24"
                      viewBox="0 0 19 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.0536 3.87819V23.1613C18.0536 23.3469 17.9007 23.5 17.7147 23.5H2.2491C2.06308 23.5 1.91016 23.3469 1.91016 23.1613V0.838693C1.91016 0.653085 2.06308 0.5 2.2491 0.5H14.6689L18.0536 3.87819Z"
                        fill="white"
                        stroke="#E5E5E5"
                      />
                      <path
                        d="M18.554 3.6708V23.1613C18.554 23.6232 18.1771 24 17.7151 24H16.5175C16.9795 24 17.3564 23.6232 17.3564 23.1613V3.6708L13.6846 0H14.8822L18.554 3.6708Z"
                        fill="#E5E5E5"
                      />
                      <path
                        d="M18.5539 3.6708H15.7149C15.2529 3.6708 14.876 3.294 14.876 2.83211V0L18.5539 3.6708Z"
                        fill="#CECECE"
                      />
                      <path
                        d="M15.0096 11.3649H5.05177C4.71741 11.3649 4.44385 11.0914 4.44385 10.7572C4.44385 10.4229 4.71741 10.1494 5.05177 10.1494H15.0096C15.3439 10.1494 15.6175 10.4229 15.6175 10.7572C15.6175 11.0975 15.35 11.3649 15.0096 11.3649Z"
                        fill="#CECECE"
                      />
                      <path
                        d="M15.0096 14.4826H5.05177C4.71741 14.4826 4.44385 14.2091 4.44385 13.8748C4.44385 13.5406 4.71741 13.2671 5.05177 13.2671H15.0096C15.3439 13.2671 15.6175 13.5406 15.6175 13.8748C15.6175 14.2152 15.35 14.4826 15.0096 14.4826Z"
                        fill="#CECECE"
                      />
                      <path
                        d="M15.0096 17.6003H5.05177C4.71741 17.6003 4.44385 17.3268 4.44385 16.9925C4.44385 16.6583 4.71741 16.3848 5.05177 16.3848H15.0096C15.3439 16.3848 15.6175 16.6583 15.6175 16.9925C15.6175 17.3329 15.35 17.6003 15.0096 17.6003Z"
                        fill="#CECECE"
                      />
                      <path
                        d="M8.41976 8.20459H0V4.79511C0 4.53986 0.206691 4.32715 0.468099 4.32715H8.41976C8.67509 4.32715 8.88786 4.53378 8.88786 4.79511V7.73662C8.88786 7.99187 8.68116 8.20459 8.41976 8.20459Z"
                        fill="#F55B4B"
                      />
                      <path
                        d="M8.88786 7.67584V7.73662C8.88786 7.99187 8.68116 8.20459 8.41976 8.20459H0V4.79511C0 4.53986 0.206691 4.32715 0.468099 4.32715H0.705191V5.54265C0.705191 6.72168 1.65963 7.68192 2.84509 7.68192H8.88786V7.67584Z"
                        fill="#DD4E43"
                      />
                      <path
                        d="M0 8.20459L1.41038 9.80905V8.20459H0Z"
                        fill="#DB1B1B"
                      />
                      <path
                        d="M2.27935 7.00118V7.40837H1.00879V7.00118H1.31883V5.4028H1.00879V4.99561H2.27935C2.57724 4.99561 2.80217 5.06246 2.96631 5.20224C3.13045 5.34202 3.20948 5.53042 3.20948 5.76137C3.20948 5.89507 3.17908 6.01662 3.12437 6.12602C3.06965 6.23541 2.9967 6.3205 2.90552 6.3752C2.81433 6.43597 2.71706 6.47243 2.60155 6.49674C2.48605 6.52105 2.34622 6.52713 2.17601 6.52713H1.94499V6.9951H2.27935V7.00118ZM1.94499 6.12602H2.03618C2.24896 6.12602 2.38878 6.08955 2.44957 6.0227C2.51036 5.95585 2.54076 5.86469 2.54076 5.76137C2.54076 5.67628 2.51644 5.59728 2.47389 5.5365C2.43133 5.47573 2.3827 5.43926 2.32799 5.42103C2.27327 5.40887 2.18208 5.39672 2.05442 5.39672H1.93891V6.12602H1.94499Z"
                        fill="white"
                      />
                      <path
                        d="M3.35596 7.40837V7.00118H3.72071V5.4028H3.35596V4.99561H4.49886C4.74203 4.99561 4.93048 5.00776 5.08246 5.03815C5.22837 5.06854 5.36819 5.13539 5.50193 5.23263C5.63568 5.33594 5.7451 5.46965 5.82413 5.63982C5.90316 5.80999 5.94572 5.99839 5.94572 6.20503C5.94572 6.37519 5.91532 6.53321 5.86061 6.68515C5.80589 6.83708 5.73294 6.95863 5.64783 7.05587C5.56272 7.14704 5.46546 7.22604 5.34387 7.28074C5.22837 7.33544 5.11894 7.3719 5.02167 7.39014C4.9244 7.40837 4.77242 7.41445 4.56573 7.41445H3.35596V7.40837ZM4.35296 7.00118H4.50494C4.68731 7.00118 4.83322 6.97687 4.94264 6.92825C5.05207 6.87963 5.13718 6.79454 5.19797 6.67907C5.26484 6.55752 5.29524 6.40558 5.29524 6.2111C5.29524 6.02878 5.26484 5.87076 5.19797 5.74314C5.1311 5.61551 5.04599 5.52435 4.93048 5.47573C4.82106 5.42711 4.67516 5.4028 4.50494 5.4028H4.35296V7.00118Z"
                        fill="white"
                      />
                      <path
                        d="M6.2251 7.40837V7.00118H6.57162V5.4028H6.2251V4.99561H8.38931V5.74314H7.92729V5.40887H7.20386V5.968H7.72667V6.3752H7.20386V7.00118H7.57469V7.40837H6.2251Z"
                        fill="white"
                      />
                      <path
                        d="M7.49575 9.335H1.4165V8.20459H8.45019V8.38691C8.44411 8.90958 8.01857 9.335 7.49575 9.335Z"
                        fill="#E5E5E5"
                      />
                    </svg>
                    <div>{row.file}</div>
                  </div>
                </TableCell>
                <TableCell align="left" className="customTableBody">
                  {row.expiryDate}
                </TableCell>
                <TableCell
                  align="left"
                  className="customTableBody"
                  sx={{
                    color: "#F4B40E",
                    fontWeight: 700,
                    fontSize: "0.75rem",
                  }}
                >
                  {row.status}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default ApplicantFileAttentionTableRow;
